import Vue from 'vue'
import Vuex from 'vuex'

import api from '@/utils/api';
import sso from '@/utils/sso'

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';

import task from './task';
import complaint from './complaint';
import file_trace from './file_trace';
import axios from "axios";

const user = {
  state: {
    login_user: {
      mis_id: '',
      username: '',
      email: '',
      avatar: '',
    },
    menu_list: [],
    role_list: []
  },
  mutations: {
    set_login_user(state, user) {
      state.login_user = user;
    },
    set_menu_list(state, menuList) {
      state.menu_list = menuList;
    },
    set_role_list(state, roleList) {
      state.role_list = roleList;
    }
  },
  getters: {
    get_login_user(state) {
      return state.login_user;
    },
    get_menu_list(state) {
      return state.menu_list;
    },
    get_role_list(state) {
      return state.role_list;
    }
  },
  actions: {
    async api_get_login_user(context) {
      return api.get('/api/task/queryLoginUser').then(res => {
        let result = res.data;
        if (result.hasOwnProperty('status') && parseInt(result['status']) === 401) {
          sso.doLogin();
          return
        }
        context.commit('set_login_user', res.data);
      }).catch(() => {
        sso.doLogin();
      })
    },
    // 仅获取用户信息，不退出登录
    async api_get_login_user_no_logout(context) {
      return axios.get('/api/task/queryLoginUser', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
      }).then(res => {
        let result = res.data;
        if (result.hasOwnProperty('status') && parseInt(result['status']) === 401) {
          return
        }
        context.commit('set_login_user', res.data);
      })
    },
    async api_get_menu_list(context) {
      return api.get('/api/uac/menu', {params: {'system': 'operation'}}).then(res => {
        let result = res.data;
        if (result.hasOwnProperty('status') && parseInt(result['status']) === 401) {
          sso.doLogin();
          return
        }
        context.commit('set_menu_list', res.data);
      })
    },
    async api_get_role_list(context) {
      return api.get('/api/uac/role').then(res => {
        const result = res.data;
        if (result.hasOwnProperty('status') && parseInt(result['status']) === 401) {
          sso.doLogin();
          return
        }
        context.commit('set_role_list', res.data);
      })
    },
    async build_main(context){
      await context.dispatch('api_get_login_user')
      await context.dispatch('api_get_menu_list')
      await context.dispatch('api_get_role_list')
    },
    async api_get_daxiang_chat_url(_commit, params) {
      return api.get('/api/daxiang/getChatUrl', {params: params});
    }
  }
};

const store = new Vuex.Store({
  modules: {
    user,
    task,
    complaint,
    file_trace
  },
  strict: debug
});

export default store
